/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getList = (payload, callback) =>
  req.list(
    c.GET_LIST,
    'api/v1/rpt/administrator/machineries/settings/machines',
    payload,
    callback
  );

export const showData = (id, payload, callback) =>
  req.item(
    c.SHOW_DATA,
    `api/v1/rpt/administrator/machineries/settings/machines/${id}`,
    payload,
    callback
  );

export const createData = (payload, callback) =>
  req.create(
    c.CREATE_DATA,
    'api/v1/rpt/administrator/machineries/settings/machines',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateData = (id, payload, callback) =>
  req.update(
    c.UPDATE_DATA,
    `api/v1/rpt/administrator/machineries/settings/machines/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeData = (id, callback) =>
  req.remove(
    c.REMOVE_DATA,
    `api/v1/rpt/administrator/machineries/settings/machines/${id}`,
    (res) => {
      if (callback) callback(res);
    }
  );
